import React from 'react';
import {
    TextField,
} from "@mui/material";
import { TextFieldProps } from "@mui/material/TextField/TextField";

export default function FormTextField(props: TextFieldProps): JSX.Element {
    return (
        <TextField
            sx={{ width: 150 }}
            size="small"
            variant="standard"
            {...props}
        />
    );
}
